<template>
  <div>
    <b-card no-body> <!-- removes default padding -->
      <b-card-header class="py-2 px-3">
        <b-row align-v="center">
          <b-col cols="6">
            <h3 class="mb-0">Past Enquiry Details</h3>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-link href="javascript:void(0)" @click="modals.show_past_enquiry_full_view = true">
              <b-icon icon="eye-fill" variant="primary"></b-icon>
              Full View
            </b-link>
          </b-col>
        </b-row>
      </b-card-header>

      <!-- Banks -->
      <b-table bordered small :items="[fi]" :fields="fiFields" responsive="sm">
        <template #thead-top>
          <tr class="bg-light font-weight-bold">
            <th colspan="4">Enquiry(ies) in the Past 12 Months (Banks)</th>
          </tr>
        </template>
      </b-table>

      <!-- Non-Banks -->
      <b-table bordered small :items="[nonFi]" :fields="fiFields" responsive="sm">
        <template #thead-top>
          <tr class="bg-light font-weight-bold">
            <th colspan="4">Enquiry(ies) in the Past 12 Months (Non-Banks)</th>
          </tr>
        </template>
      </b-table>

      <!-- Current Enquiry -->
      <b-table bordered small :items="currentItems" :fields="currentFields" responsive="sm">
        <template #thead-top>
          <tr class="bg-light font-weight-bold">
            <th colspan="3">Current enquiry</th>
          </tr>
        </template>
      </b-table>
    </b-card>

    <!-- Modal -->
    <PastEnquiryModal
      :show_past_enquiry_full_view.sync="modals.show_past_enquiry_full_view"
      :fi="fi"
      :non-fi="nonFi"
      :req-no="reqNo"
      :user-id="userId"
    />
  </div>
</template>

<script>
import PastEnquiryModal from "@/views/CustomerProfile/CustomerModals/PastEnquiryModal.vue";
export default {
  name: 'PastEnquiryDetails',
  props: {
    fi: { type: Object, required: true },
    nonFi: { type: Object, required: true },
    reqNo: { type: String, required: true },
    userId: { type: String, required: true }
  },
  components: {
    PastEnquiryModal
  },
  data() {
    return {
          modals: {
          show_past_enquiry_full_view: false
        }
    }
  },
  computed: {
    fiFields() {
      return [
        { key: 'EnqDate', label: 'Enquiry Date/Time' },
        { key: 'EnqNo', label: 'Enquiry Number' },
        { key: 'Purpose', label: 'Enquiry Type' },
        { key: 'Enquirer', label: 'Enquirer ID' }
      ]
    },
    currentFields() {
      return [
        { key: 'reqNo', label: 'Enquiry Number' },
        { key: 'reportType', label: 'Report Enquiry Type' },
        { key: 'userId', label: 'Enquirer ID' }
      ]
    },
    currentItems() {
      return [
        {
          reqNo: this.reqNo,
          reportType: '', // map from API if available
          userId: this.userId
        }
      ]
    }
  }
}
</script>

<style scoped>
.bg-light {
  background-color: #eaeaea !important; /* light grey header like screenshot */
}
</style>